import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { anonymousRoutes } from '../anonymous/routes';
import { authRoutes } from '../auth/routes';
import { dashboardRoutes } from '../dashboard/routes';
import { onboardingRoutes } from '../onboarding/routes';
import { CheckAppVersion } from '../shared/components/checkAppVersion';
import { ShareEntry } from '../issues/components/shareEntry';
import { ShareView } from '../issues/components/shareView';
import { ErrorBoundary } from '../shared/logging/errorBoundary';
import { Home } from './home';
import { Tag } from './tag';

const ErrorBoundaryLayout = () => (
  <ErrorBoundary>
    <Outlet />
    <CheckAppVersion />
  </ErrorBoundary>
);

export const routes: RouteObject[] = [
  {
    element: <ErrorBoundaryLayout />,
    children: [
      { path: '/', element: <Home /> },
      {
        path: '/dashboard',
        element: <Navigate to="/" replace />,
      },
      {
        path: '/dashboard/*',
        element: <Navigate to="/" replace />,
      },
      ...dashboardRoutes,
      // A resolver entry like `/:tagId` below: ShareEntry picks the signed-in
      // (ProtectedRoute → Layout → ShareView via Outlet) or the anonymous
      // view. Lives here rather than under dashboardRoutes so a signed-out
      // visitor is not bounced to /login before the switch can run. The index
      // child is only reached on the signed-in branch (via ProtectedRoute's
      // Outlet); AnonymousShareView renders ShareView itself.
      {
        path: '/share/:token',
        element: <ShareEntry />,
        handle: { requiredPermission: 'none' },
        children: [
          {
            index: true,
            element: <ShareView />,
            handle: { requiredPermission: 'none' },
          },
        ],
      },
      ...onboardingRoutes,
      ...authRoutes,
      ...anonymousRoutes,
      { path: ':tagId', element: <Tag /> }, // default route for tags (needs to be last)
    ],
  },
];
